export default function Adjust(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.5 4.16667H15M11.4583 2.5V5.83333M10.8333 4.16667H2.5M5.83333 10H2.5M8.95833 8.33333V11.6667M17.5 10H9.16667M17.5 15.8333H15M11.4583 14.1667V17.5M10.8333 15.8333H2.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
